import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export default function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      mirrors: {
        mirrors_list_js: {
          header: 'JS_HEADER',
          button_add: 'JS_ADD_BTN',
          status_enabled: 'JS_ENABLED_STATUS',
          status_disabled: 'JS_DISABLED_STATUS',
          modal_window: {
            remove_message: 'JS_REMOVE_MESSAGE',
            remove_title: 'JS_REMOVE_TITLE',
            ok: 'JS_ANSWER_YES',
            cancel: 'JS_ANSWER_NO',
          },
        },
        mirrors_list_no_js: {
          header: 'NO_JS_HEADER',
          button_add: 'NO_JS_ADD_BTN',
          status_enabled: 'NO_JS_ENABLED_STATUS',
          status_disabled: 'NO_JS_DISABLED_STATUS',
          modal_window: {
            remove_message: 'NO_JS_REMOVE_MESSAGE',
            remove_title: 'NO_JS_REMOVE_TITLE',
            ok: 'NO_JS_ANSWER_YES',
            cancel: 'NO_JS_ANSWER_NO',
          },
        },
      },
    },
  }));
}
